import moment from 'moment';

import {
  SET_IS_LOADING,
  SET_SCHEDULING_OTHERS,
  CLEAR_SCHEDULING_OTHERS
} from './constants';

const defaultState = {
  isLoading: false,
  submit: {
    id: '',
    title: '',
    employeeId: '',
    dateStart: moment(moment.now()).format('YYYY-MM-DD'),
    timeStart: '',
    dateEnd: moment(moment.now()).format('YYYY-MM-DD'),
    timeEnd: '',
    observation: '',
    situationId: 1,
    typeId: 2
  }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_IS_LOADING: {
      return {
        ...state,
        isLoading: action?.isLoading
      }
    }
    case SET_SCHEDULING_OTHERS: {
      const { id, title, observation, startDateTime, endDateTime } = action.data || {};

      return {
        ...state,
        submit: {
          id,
          title,
          observation,
          dateStart: startDateTime?.split(' ')[0],
          timeStart: startDateTime?.split(' ')[1]?.substring(0, 5),
          dateEnd: endDateTime?.split(' ')[0],
          timeEnd: endDateTime?.split(' ')[1]?.substring(0, 5)
        }
      }
    }
    case CLEAR_SCHEDULING_OTHERS: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
}